import { HttpTypes } from '@/types';
import { StoreCollection } from '@/types/http';
import { AxiosInstance, AxiosRequestConfig } from 'axios';

class Collections {
  private client: AxiosInstance;
  private routePath = '/product/store';
  public host = '';

  constructor(client: AxiosInstance) {
    client.interceptors.request.use();

    this.client = client;
  }

  interceptRequest(config: AxiosRequestConfig) {
    config.headers = {
      ...config.headers,
    };

    return config;
  }

  async list(queryParams: HttpTypes.FindParams): Promise<HttpTypes.StoreCollectionsListResponse> {
    this.interceptRequest({ ...this.client.request });
    const result = await this.client.get(`${this.routePath}/collections/list`, {
      params: queryParams,
      headers: {
        Origin: this.host,
        'X-Jstore-Host': this.host,
      },
    });
    return result.data;
  }

  async detail(slug: string): Promise<HttpTypes.IResponse<StoreCollection>> {
    this.interceptRequest({ ...this.client.request });
    const result = await this.client.get(`${this.routePath}/collections/metadata/${slug}`, {
      headers: {
        Origin: this.host,
        'X-Jstore-Host': this.host,
      },
    });
    return result.data;
  }
}

export default Collections;
